/** Assign the submission identity before React Query starts its retry lifecycle. */
export function createActionSubmit<
  Input extends { idempotencyKey?: string },
  Options,
  Output,
>(
  mutation: {
    mutate(input: Input, options?: Options): void;
    mutateAsync(input: Input, options?: Options): Promise<Output>;
  },
  newKey: () => string,
) {
  const keyed = (input: Input): Input => ({
    ...input,
    idempotencyKey: input.idempotencyKey ?? newKey(),
  });
  return {
    mutate: (input: Input, options?: Options) =>
      mutation.mutate(keyed(input), options),
    mutateAsync: (input: Input, options?: Options) =>
      mutation.mutateAsync(keyed(input), options),
  };
}
